import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OperationsService } from '../../../../core/services/operations.service';
import { AssegnazioneGruppiTerritorialiRequest } from '../../../models/dto/assegnazione-gruppi-territoriali-request';
import { GruppoTerritoriale } from '../../../models/gruppo-territoriale';
import { GruppoVisibilita } from '../../../models/gruppo-visibilita';
import { Utente } from '../../../models/utente';
import {
  AssegnazioneCompetenzaFormComponent
} from '../../assegnazione/competenza/assegnazione-competenza-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: '[assegnatari_modal]',
  templateUrl: 'assegnatari-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class AssegnatariModalComponent {

  @Input()
  fascicoloId: string;

  @ViewChild('assegnazioneCompetenzaForm')
  assegnazioneCompetenzaForm: AssegnazioneCompetenzaFormComponent;

  @Input()
  selectedUser: Utente;

  @Input()
  tipoFascicolo: string;

  @Output()
  onUpdate = new EventEmitter();

  request: AssegnazioneGruppiTerritorialiRequest;
  gruppi: GruppoTerritoriale[];
  utenteCompetente: Utente;
  gruppiCompetenti: GruppoVisibilita[];
  wizard: boolean = false;

  constructor(private operationsService: OperationsService) {}

  initForm(url,user) {
    openModal('assegnatariModal');
    this.selectedUser = user;
  }

  update(user: Utente, gruppi: GruppoTerritoriale[]) {
    this.request = new AssegnazioneGruppiTerritorialiRequest();
    this.request.utente = user;
    this.request.gruppi = gruppi;
    if (this.gruppiCompetenti[0].id != gruppi[0].id) {
      this.request.cambioUfficio = true;
    }
    this.operationsService.updateUtenteAssegnatario(this.fascicoloId, this.request).subscribe(response => this.manageModal(response));
  }

  reset() {
    this.assegnazioneCompetenzaForm.ngOnInit()
    this.assegnazioneCompetenzaForm.setUtenteCompetente();
  }

  manageModal(response) {
    this.onUpdate.emit(response);
    closeModal('assegnatariModal');
  }
}
